import planEnum from './planEnum';

const planCardListPro = [
  {
    planKeyName: planEnum.BASIC_PRO,
    planPrice: {
      mo: 0,
      yr: 0,
    },
    planSpecialPrice: {
      mo: {
        isActive: false,
        price: 0,
        showWebOnly: false,
      },
      yr: {
        isActive: false,
        price: 0,
        showWebOnly: false,
      },
    },
    isFeatureActiveMap: {
      eventVideo: true,
      continuousVideo: false,
      videoClip: false,
      sleepTracking: false,
      snapCute: false,
      breathing: false,
    },
    featureData: {
      eventVideoDay: 2,
      continuousVideoDay: 6,
      cameraShareCnt: 5,
      // sleeplogHistoryDay: 0,
      // snapCuteCnt: 0,
    },
    showTag: false,
  },
  {
    planKeyName: planEnum.ULTRA_CARE,
    planPrice: {
      mo: 8,
      yr: 80,
    },
    planSpecialPrice: {
      mo: {
        isActive: false,
        price: 19,
        showWebOnly: false,
      },
      yr: {
        isActive: false,
        price: 200,
        showWebOnly: false,
      },
    },
    isFeatureActiveMap: {
      eventVideo: true,
      continuousVideo: true,
      videoClip: true,
      sleepTracking: true,
      snapCute: true,
      breathing: true,
    },
    featureData: {
      eventVideoDay: 7,
      continuousVideoDay: 2,
      cameraShareCnt: 50,
      sleeplogHistoryDay: 'Unlimited',
      snapCuteCnt: 50,
    },
    showTag: false,
  },
  {
    planKeyName: planEnum.ELITE_CARE,
    planPrice: {
      mo: 12,
      yr: 110,
    },
    planSpecialPrice: {
      mo: {
        isActive: false,
        price: 19,
        showWebOnly: false,
      },
      yr: {
        isActive: false,
        price: 200,
        showWebOnly: false,
      },
    },
    isFeatureActiveMap: {
      eventVideo: true,
      continuousVideo: true,
      videoClip: true,
      sleepTracking: true,
      snapCute: true,
      breathing: true,
    },
    featureData: {
      eventVideoDay: 7,
      continuousVideoDay: 7,
      cameraShareCnt: 'Unlimited',
      sleeplogHistoryDay: 'Unlimited',
      snapCuteCnt: 150,
    },
    showTag: false,
  },
  {
    planKeyName: planEnum.ELITE_PRO,
    planPrice: {
      mo: 24,
      yr: 240,
    },
    planSpecialPrice: {
      mo: {
        isActive: false,
        price: 19,
        showWebOnly: false,
      },
      yr: {
        isActive: true,
        price: 200,
        showWebOnly: false,
      },
    },
    isFeatureActiveMap: {
      eventVideo: true,
      continuousVideo: true,
      videoClip: true,
      sleepTracking: true,
      snapCute: true,
      breathing: true,
    },
    featureData: {
      eventVideoDay: 30,
      continuousVideoDay: 30,
      cameraShareCnt: 'Unlimited',
      sleeplogHistoryDay: 'Unlimited',
      snapCuteCnt: 'Unlimited',
    },
    showTag: true,
  },
];

export default planCardListPro;
